export const FLOATING_POPOVER_MODE = {
  HOVER: "hover",
  CLICK: "click",
  TOOLTIP: "tooltip",
};

export const FLOATING_POPOVER_VARIANT = {
  DEFAULT: "default",
  BRAND: "brand",
  DARK: "dark",
  DANGER: "danger",
  WARNING: "warning",
};

export const FLOATING_POPOVER_PLACEMENT = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
};

export const DEFAULT_OFFSET = 12;
export const DEFAULT_MAX_WIDTH = 320;
export const DEFAULT_Z_INDEX = 9999;

export const FLOATING_POPOVER_VARIANTS = {
  default: {
    panelClassName: "bg-white",
    panelBoxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.05)",
    border: "1px solid #f1f5f9",
    borderColor: "#f1f5f9",
    arrowBorderColor: "#f1f5f9",
    arrowBackground: "#ffffff",
    contentClassName: "text-slate-900",
  },
  brand: {
    panelClassName: "bg-white",
    panelBoxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.05)",
    border: "1px solid #bfdbfe",
    borderColor: "#bfdbfe",
    arrowBorderColor: "#bfdbfe",
    arrowBackground: "#ffffff",
    contentClassName: "text-slate-900",
  },
  dark: {
    panelClassName: "bg-slate-900",
    panelBoxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    border: "1px solid #1e293b",
    borderColor: "#1e293b",
    arrowBorderColor: "#1e293b",
    arrowBackground: "#0f172a",
    contentClassName: "text-white",
  },
  danger: {
    panelClassName: "bg-white",
    panelBoxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(239, 68, 68, 0.1)",
    border: "1px solid #fca5a5",
    borderColor: "#fca5a5",
    arrowBorderColor: "#fca5a5",
    arrowBackground: "#ffffff",
    contentClassName: "text-slate-900",
  },
  warning: {
    panelClassName: "bg-white",
    panelBoxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(245, 158, 11, 0.1)",
    border: "1px solid #fde047",
    borderColor: "#fde047",
    arrowBorderColor: "#fde047",
    arrowBackground: "#ffffff",
    contentClassName: "text-slate-900",
  },
};

